/**
 * DOM节点操作
 */

/**
 * 获取指定DOM节点相对于指定容器的绝对坐标
 * 当不指定相对容器时，则相对于文档根节点
 * @param node
 * @param container
 */
export function getOffset(node: HTMLElement, container?: HTMLElement) {
  let top = 0;
  let left = 0;
  const width = node.offsetWidth;
  const height = node.offsetHeight;
  let _node = node;
  do {
    top += _node.offsetTop;
    left += _node.offsetLeft;
    _node = _node.offsetParent as HTMLElement;
  } while (_node && _node instanceof HTMLElement);

  // 减去容器的绝对距离
  if (container) {
    const containerOffset = getOffset(container);
    if (containerOffset) {
      left -= containerOffset.left;
      top -= containerOffset.top;
    }
  }

  return { top, left, width, height };
}

/**
 * 检测DOM节点是否是可编辑节点，例如：input/textareat/div[contenteditable]
 * @param node
 */
export function isEditableNode(node: HTMLElement | Node | EventTarget | null) {
  const inputableNodes = ['INPUT', 'TEXTAREA'];
  if (!(node instanceof HTMLElement)) return false;
  const editable = node.contentEditable;
  return inputableNodes.includes(node.nodeName) || editable === 'true';
}

export default {
  getOffset,
  isEditableNode,
};
